// @flow
import * as actionTypes from "../constants/actionTypes";
import { push } from "connected-react-router";
import type { User } from "../reducers/auth";

export type LoginAction = {
  type: "LOGIN",
  payload: {
    values: {
      userName: string,
      passwored: string
    },
    from: string
  }
};
export type LoginWithTokenAction = {
  type: "LOGIN_WITH_TOKEN",
  payload: {
    token: string
  }
};
export type LoginSuccessAction = {
  type: "LOGIN_SUCCESS",
  payload: {
    user: User
  }
};
export type LoginErrorAction = {
  type: "LOGIN_ERROR",
  payload: {
    error: string
  }
};
export type LogoutAction = {
  type: "LOGOUT"
};
export type LogoutSuccessAction = {
  type: "LOGOUT_SUCCESS"
};
export type LogoutErrorAction = {
  type: "LOGOUT_ERROR",
  payload: {
    error: string
  }
};
export type RecoverPasswordAction = {
  type: "RECOVER_PASSWORD",
  payload: {
    email: string
  }
};
export type RecoverPasswordSuccessAction = {
  type: "RECOVER_PASSWORD_SUCCESS"
};
export type RecoverPasswordErrorAction = {
  type: "RECOVER_PASSWORD_ERROR",
  payload: {
    error: string
  }
};

export type Action =
  | LoginAction
  | LoginWithTokenAction
  | LoginSuccessAction
  | LoginErrorAction
  | LogoutAction
  | LogoutSuccessAction
  | LogoutErrorAction
  | RecoverPasswordAction
  | RecoverPasswordSuccessAction
  | RecoverPasswordErrorAction;

export function login(
  values: {
    userName: string,
    passwored: string
  },
  from: string
): LoginAction {
  return {
    type: actionTypes.LOGIN,
    payload: {
      values,
      from
    }
  };
}

export function loginWithToken(token: string): LoginWithTokenAction {
  return {
    type: actionTypes.LOGIN_WITH_TOKEN,
    payload: {
      token
    }
  };
}

export function loginSuccess(user: User): LoginSuccessAction {
  return {
    type: actionTypes.LOGIN_SUCCESS,
    payload: {
      user
    }
  };
}

export function loginError(error: string): LoginErrorAction {
  return {
    type: actionTypes.LOGIN_ERROR,
    payload: {
      error
    }
  };
}

export function logout(): LogoutAction {
  return {
    type: actionTypes.LOGOUT
  };
}

export function logoutSuccess(): LogoutSuccessAction {
  return {
    type: actionTypes.LOGOUT_SUCCESS
  };
}

export function logoutError(error: string): LogoutErrorAction {
  return {
    type: actionTypes.LOGOUT_ERROR,
    payload: {
      error
    }
  };
}

export function recoverPassword(email: string): RecoverPasswordAction {
  return {
    type: actionTypes.RECOVER_PASSWORD,
    payload: {
      email
    }
  };
}

export function recoverPasswordSuccess(): RecoverPasswordSuccessAction {
  return {
    type: actionTypes.RECOVER_PASSWORD_SUCCESS
  };
}

export function recoverPasswordError(
  error: string
): RecoverPasswordErrorAction {
  return {
    type: actionTypes.RECOVER_PASSWORD_ERROR,
    payload: {
      error
    }
  };
}

export function redirectToPage(path: string) {
  return push(path);
}



// WEBPACK FOOTER //
// ./src/actions/auth.js